(function () {
  function bindGarageTrigger() {
    var trigger = document.getElementById('gv-garage-trigger');
    if (!trigger) return;

    // Prevent multiple bindings from MutationObserver
    if (trigger.dataset.gvBound === '1') return;
    trigger.dataset.gvBound = '1';

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      var $ = window.jQuery;
      if (!$) return;

      var $popup  = $('#gv-save-vehicles .gv-vehicles .popup');
      var $toggle = $('#gv-save-vehicles .gv-vehicles .toggle').first();

      if ($popup.length) {
        $popup.stop(true, true).slideToggle(150);
        trigger.setAttribute('aria-expanded', $popup.is(':visible') ? 'true' : 'false');
      } else if ($toggle.length) {
        $toggle.trigger('click');
      }
    }, { passive: false });

    // Add outside click handler once
    document.addEventListener('click', function (e) {
      var $ = window.jQuery;
      if (!$) return;

      var $popup = $('#gv-save-vehicles .gv-vehicles .popup');
      if (!$popup.length || !$popup.is(':visible')) return;

      // If the click target is NOT inside popup and not the trigger, close
      if (!e.target.closest('#gv-save-vehicles') && !e.target.closest('#gv-garage-trigger')) {
        $popup.stop(true, true).slideUp(150);
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGarageTrigger);
  } else {
    bindGarageTrigger();
  }

  var container = document.getElementById('gv-save-vehicles');
  if (container) {
    new MutationObserver(bindGarageTrigger).observe(container, { childList: true, subtree: true });
  }
})();